// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__sl3ct","modalFooterButton":"ModalNotes_modalFooterButton__3iiJ-"};